import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .block-wrapper {
      padding: 0;
    }

    :host {
      --main-carousel-img-height: calc(370rem / var(--default-rem-px-count));
      --selected-variant-padding-width: 2px;
      --selected-variant-border-width: 1px;
      --hero-image-column-start: 2;
      --hero-image-column-end: 8;
      --hero-image-grid-column: var(--hero-image-column-start) /
        var(--hero-image-column-end);
      --text-content-column-start: 2;
      --text-content-column-end: 8;
      --text-content-grid-column: var(--text-content-column-start) /
        var(--text-content-column-end);
      --cta-button-column-start: var(--text-content-column-start);
      --cta-button-column-end: var(--text-content-column-end);
      --cta-button-grid-column: var(--cta-button-column-start) /
        var(--cta-button-column-end);
    }

    .jesse-layout {
      grid-template-rows:
        repeat(8, auto)
        var(--bottom-padding-height)
        [last-line];
    }

    .block-title {
      grid-column: 2 / 8;
      grid-row: 2;
      margin-bottom: calc(15em / var(--default-rem-px-count));
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
      grid-column: var(--text-content-grid-column);
      padding-bottom: calc(40em / var(--default-rem-px-count));
    }

    .block-label {
      padding-bottom: calc(15em / var(--default-rem-px-count));
    }

    .carousel-hero {
      grid-column: var(--hero-image-grid-column);
      grid-row: 4;
    }

    .barrels {
      grid-column: var(--text-content-grid-column);
      grid-row: 5;
      padding-bottom: calc(50em / var(--default-rem-px-count));
      display: flex;
      flex-direction: column;
    }

    .primary-cta {
      grid-row: 6;
      grid-column: 2 / 6;
    }

    .secondary-cta {
      grid-row: 7;
      grid-column: 2 / 6;
    }

    .stupid-spacer {
      grid-row: 8;
    }

    .carousel-images {
      display: none;
    }

    .all-patterns-btn {
      padding-left: calc(4em / var(--default-rem-px-count));
    }

    .all-patterns-btn img {
      transform: rotate(180deg);
      height: calc(8em / var(--default-rem-px-count));
      width: calc(8em / var(--default-rem-px-count));
    }

    .all-patterns-btn p {
      padding-left: calc(8em / var(--default-rem-px-count));
      margin-bottom: calc(-1em / var(--default-rem-px-count));
    }

    .carousel-images .image {
      margin-bottom: 1em;
      margin-right: 1px;
    }

    .carousel-images .image img {
      width: calc(
        100% -
          (
            2 *
              (
                var(--selected-variant-padding-width) +
                  var(--selected-variant-border-width)
              )
          )
      );
    }

    .selected-image {
      padding: var(--selected-variant-padding-width);
      border: var(--selected-variant-border-width) solid #222222;
    }

    .carousel-arrows,
    .carousel-arrows-sticky {
      width: 100%;
      display: flex;
      justify-content: space-between;
      position: absolute;
    }

    .carousel-arrows {
      top: calc(50% - calc(40em / var(--default-rem-px-count)));
    }

    .carousel-arrows-sticky {
      top: calc(50% - calc(20em / var(--default-rem-px-count)));
    }

    .carousel-arrows-sticky span {
      margin: 0;
    }

    #download-icon {
      display: none;
    }

    .carousel-bottom-row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: calc(18em / var(--default-rem-px-count));
      padding-top: calc(7em / var(--default-rem-px-count));
      border-top: 1px solid #c0c0c0;
    }

    .carousel-arrows span,
    .carousel-bottom-row span {
      cursor: pointer;
      width: calc(40em / var(--default-rem-px-count));
      height: calc(40em / var(--default-rem-px-count));
      display: flex;
      align-items: center;
    }

    .carousel-arrows span {
      justify-content: center;
      margin: calc(5em / var(--default-rem-px-count));
    }

    .carousel-bottom-row span {
      justify-content: right;
    }

    .carousel-arrows:hover span {
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.4);
    }

    .carousel-arrows span img {
      width: calc(9em / var(--default-rem-px-count));
      height: calc(18em / var(--default-rem-px-count));
    }

    .left-arrow {
      transform: rotate(180deg);
    }

    .carousel-bottom-row span img {
      width: calc(12em / var(--default-rem-px-count));
    }

    .image-caption {
      width: 100%;
      padding-top: calc(6em / var(--default-rem-px-count));
    }

    .not-selected-image {
      padding: 3px;
    }

    .carousel-hero-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      margin: 0 auto;
      position: relative;
    }

    .carousel-img {
      max-height: var(--main-carousel-img-height);
      max-width: calc(100% - 80px);
    }

    .barrels {
      font-size: calc(14em / var(--default-rem-px-count));
      letter-spacing: -0.21px;
    }

    #sticky-hero-wrapper-mobile {
      position: fixed;
      left: 0;
      right: 0;
      background-color: #ffffff;
      display: inline-grid;
      grid-template-columns: 3fr 4fr;
      gap: 1em;
      padding: var(--between-column-padding);
      padding-bottom: 1em;
      z-index: 100;
      border-bottom: 1px solid #ccc;
    }

    .hide-sticky-wrapper {
      visibility: hidden !important;
    }

    .carousel-hero-content-wrapper {
      display: flex;
      position: relative;
      justify-content: center;
    }

    .sticky-header-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .sticky-header-content > p.image-caption {
      padding-top: calc(20em / var(--default-rem-px-count));
    }

    .carousel-img-sticky {
      max-height: calc(220em / var(--default-rem-px-count));
      max-width: 100%;
    }

    @media (min-width: 600px) {
      :host {
        --main-carousel-img-height: calc(700em / var(--default-rem-px-count));
        --hero-image-column-start: 3;
        --hero-image-column-end: 8;
        --text-content-column-start: 9;
        --text-content-column-end: 14;
        --cta-button-column-end: 13;
      }

      :host .block-grid {
        grid-template-rows:
          minmax(var(--top-padding-height), auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          var(--bottom-padding-height)
          [last-line];
      }

      .title-header {
        grid-row: 2;
      }

      .carousel-hero {
        grid-row: 3 / 9;
        position: relative;
        width: 100%;
      }

      .description {
        grid-row: 2;
      }

      .barrels {
        grid-row: 3;
      }

      .primary-cta {
        grid-row: 6;
        grid-column: 9 / 11;
      }

      .secondary-cta {
        grid-row: 6;
        grid-column: 11 / 13;
      }

      .carousel-images {
        grid-column: 2;
        grid-row: 3 / 6;
        display: unset;
      }

      .carousel-img {
        max-width: 100%;
      }

      #download-icon {
        display: flex;

        p {
          margin-right: 8px;
          font-size: calc(12rem / var(--default-rem-px-count));
          text-wrap: nowrap;
          font-weight: 500;
        }
      }

      horizontal-rule {
        grid-column: 2 / 14;
        grid-row: 1 / last-line;
      }
    }

    @media (min-width: 1024px) {
      :host {
        --text-content-column-end: 13;
        --cta-button-column-end: 12;
      }
    }
  `,
];
